export enum ButtonTitleKeyEnum {
    ATTACH_DOCUMENT = 'attachDocumentButtonTitle',
    VIEW_DOCUMENT = 'viewDocumentButtonTitle',
}
